import { components } from "react-select";

export const CustomQuoteOption = (props: any) => {
  const { label, referenceNumber } = props.data;

  return (
    <components.Option {...props}>
      <div className="d-flex justify-content-between align-items-center">
        <span className="fw-medium">{label}</span>
        <span
          style={{
            fontSize: "14px",
          }}
        >
          {referenceNumber}
        </span>
      </div>
    </components.Option>
  );
};

export const CustomSingleValue = (props: any) => {
  const { label } = props.data;

  return (
    <components.SingleValue {...props}>
      <div className="d-flex align-items-center">
        <span className="fw-medium">{label}</span>
      </div>
    </components.SingleValue>
  );
};
